var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"pa-0 pa-md-3",attrs:{"cols":"12","md":"3","order":"last","order-md":"first"}}),_c('v-col',{attrs:{"cols":"12","md":"9"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clicked}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }